import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import { AgGridModule } from 'ag-grid-angular';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmReplaceExistingDocumentComponent } from './dialogs/confirm-replace-existing-document/confirm-replace-existing-document.component';
import { CancelCwsFormConfirmationComponent } from './dialogs/cancel-cws-form-confirmation/cancel-cws-form-confirmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomCommonIconComponent } from './custom-icon/custom-common-icon/custom-common-icon.component';
import {MatChipsModule} from '@angular/material/chips';
import { SharedSupplierFieldComponent } from './shared-supplier-field/shared-supplier-field/shared-supplier-field.component';
import { SharedDirectiveDirective } from './directive/shared-directive.directive';
import { CustomFloatingFilterComponent } from './custom-icon/custom-floating-filter/custom-floating-filter.component';


const MaterialComponents=[
    MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatTabsModule,
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatDialogModule,
        MatProgressBarModule,
        MatCardModule,
        MatButtonToggleModule,
        MatDividerModule,
        MatRadioModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatListModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatExpansionModule,
        AgGridModule,
        MatSidenavModule,
        MatDatepickerModule,
        MatNativeDateModule,
        AgGridModule.withComponents([CustomFloatingFilterComponent]),
]
@NgModule({
    providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, verticalPosition: 'top' } }
    ],
    imports:[CommonModule, MaterialComponents, ReactiveFormsModule, FormsModule],
    exports: [
        MaterialComponents,
        CancelCwsFormConfirmationComponent,
        MatChipsModule,
        SharedSupplierFieldComponent,
        SharedDirectiveDirective
    ],
    declarations: [
      ConfirmReplaceExistingDocumentComponent,
      CancelCwsFormConfirmationComponent,
      CustomCommonIconComponent,
      SharedSupplierFieldComponent,
      SharedDirectiveDirective,
      CustomFloatingFilterComponent
    ]
})
export class MaterialModule { }
